import useCustomEffect from "../../../../../../hooks/useCustomEffect";
import HouserulesFormView from "./HouserulesFormView";

function HouserulesForm({
  relations,
  fetchRelation,
  selectedStep,
  selectedStepIndex,
  setFlowData,
  submitError,
}) {
  /**
   * This effect will fetch the files relation on mount.
   */
  useCustomEffect(() => {
    fetchRelation("files");
  }, []);

  /**
   * This method will handle the on houserules change event
   * @param {string} fileId
   */
  function onHouserulesChange(fileId) {
    setFlowData((prev) => ({
      ...prev,
      steps: prev.steps.map((step) => {
        if (step.id === selectedStep.id) {
          return {
            ...step,
            file_id: fileId,
          };
        }

        return step;
      }),
    }));
  }

  /**
   * This method will handle the on houserules expiration change event
   * @param {event} e
   */
  function onHouserulesExpirationChange(e) {
    const houserules_expiration = e.target.value;
    setFlowData((prev) => ({
      ...prev,
      steps: prev.steps.map((step) => {
        if (step.id === selectedStep.id) {
          return {
            ...step,
            houserules_expiration: houserules_expiration,
          };
        }

        return step;
      }),
    }));
  }

  return (
    <HouserulesFormView
      relations={relations}
      selectedStep={selectedStep}
      selectedStepIndex={selectedStepIndex}
      onHouserulesChange={onHouserulesChange}
      onHouserulesExpirationChange={onHouserulesExpirationChange}
      submitError={submitError}
    />
  );
}

export default HouserulesForm;
